module.exports = __webpack_public_path__ + "img/组 1325@2x (1).7b707ce8.png";